<script>
export default {
  name: 'Card',
}
</script>

<script setup>
import useNodeProps from "@/Composables/useNodeProps"
import useSearchOrSelectImage from "@/Composables/useSearchOrSelectImage"
import EditableNode from "@/Components/Inputs/BlockEditor/Extension/Components/EditableNodeWrapper.vue"
import { SecondaryButton } from "@codinglabsau/ui"
import { PhotoIcon } from "@heroicons/vue/24/outline"
import { NodeViewWrapper, nodeViewProps, NodeViewContent } from "@tiptap/vue-3"

// Tools
import EditCard from "@/Components/Inputs/BlockEditor/Extension/Modals/Card/EditCard.vue"
import SelectPreset from "@/Components/Inputs/BlockEditor/Extension/Modals/Card/SelectPreset.vue";

const props = defineProps({
  ...nodeViewProps,
})

let { href, src, alt, size, padding, target} = useNodeProps(props)

const { openImageModal } = useSearchOrSelectImage((image) => src.value = image.src)
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <EditCard
          v-model:href="href"
          v-model:size="size"
          v-model:padding="padding"
          v-model:target="target"
        />
        <SelectPreset
          v-model:size="size"
          v-model:padding="padding"
        />
      </template>
      <template #content>
        <div class="flex not-prose" :class="['p-' + padding, 'space-x-' + padding]">
          <div class="flex-shrink-0 group">
            <div
              v-if="src"
              class="relative w-full h-full"
            >
              <div class="absolute p-1 top-0 right-0 left-0 bottom-0 hidden group-hover:flex flex-col items-center justify-center space-y-1">
                <SecondaryButton
                  as="button"
                  @click.prevent="openImageModal"
                  class="!p-2 w-full h-full justify-center cursor-pointer"
                >
                  {{ __('Change') }}
                </SecondaryButton>
                <SecondaryButton
                  as="button"
                  @click.prevent="src = null" icon
                  class="!p-2 w-full h-full justify-center text-red-500 cursor-pointer"
                >
                  {{ __('Remove') }}
                </SecondaryButton>
              </div>
              <img
                  :src="src"
                  :alt="alt"
                  class="object-cover"
                  :class="`h-${size} w-${size} ${padding === 0  ? 'rounded-l-xl' : 'rounded-xl'}`"
              >
            </div>
            <SecondaryButton
              v-else
              @click.prevent="openImageModal"
              as="button"
              class="flex flex-col items-center justify-center border-2 border-gray-200 hover:border-gray-400 border-dashed"
              :class="`h-24 w-24 ${padding === 0  ? 'rounded-l-xl' : 'rounded-xl'}`"
            >
              <PhotoIcon class="w-10 h-10 text-gray-300" />
              <span class="text-xs font-bold text-center text-gray-500">
                {{ __('Select or upload') }}
              </span>
            </SecondaryButton>
          </div>
          <node-view-content class="w-full items-start"></node-view-content>
        </div>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
